import styled from 'styled-components';

const StyledAccordionWrapper = styled.div`
  position: relative;
  padding-right: 64px;
  padding-left: 64px;
  padding-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  text-align: center;
  .accordion--wrap{
    position: relative;
    width: 66.66%;
    margin: 0 auto;
    h5{
      text-align: left;
      margin: 0 auto ${props => props.theme.components_spacing_desk.large}px;
    }
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px;
    .accordion--wrap{
      width: 83%
    }
  }
  @media screen and (max-width: 1023px){
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    h5{
      margin: 0 auto ${props => props.theme.components_spacing_tablet.large}px;
    }
  }
  @media screen and (max-width: 767px){
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .accordion--wrap{
      width: 100%;
      h5{
        margin: 0 auto ${props => props.theme.components_spacing_tablet.large}px;
      }
    }
  }
`;

export {
  StyledAccordionWrapper,
};

